<script>
    import { onMount } from "svelte";
    import { Chart, registerables } from "chart.js";
    import annotationPlugin from "chartjs-plugin-annotation";

    Chart.register(...registerables);
    Chart.register(annotationPlugin);

    let canvas;
    let chart;
    let ctx;
    export let line_value = 25;
    export let chart_data;
    export let selected_prop;
    export let league = "nba";
    $: if(chart) updateChart(chart, false, line_value);
    $: if(chart) updateChart(chart, true, chart_data, selected_prop);
    function getChartData() {
        let labels = [];
        let data = [];
        if(league == "nba"){
            //add points+rebounds+assists and blocks+steals to data
            for (var stat_entry of chart_data) {
                stat_entry["points+reb+ast"] = parseInt(stat_entry["points"]) + parseInt(stat_entry["rebounds"]) + parseInt(stat_entry["assists"]);
                stat_entry["steals+blocks"] = parseInt(stat_entry["blocks"]) + parseInt(stat_entry["steals"]);
            }
        }
        else if (league == "mlb"){
            for (var stat_entry of chart_data) {
                // check if stat_entry contains the prop strikouts so that we can distinguish pitchers from batters
                stat_entry["earned runs"] = parseInt(stat_entry["earned_runs"]);
                stat_entry["hits allowed"] = parseInt(stat_entry["hits_allowed"]);
                stat_entry["walks allowed"] = parseInt(stat_entry["walks_allowed"]);
                stat_entry["innings pitched"] = parseFloat(stat_entry["innings_pitched"]);

                stat_entry["total bases"] = parseInt(stat_entry.singles) + parseInt(stat_entry.doubles) * 2 + parseInt(stat_entry.triples) * 3  + parseInt(stat_entry.homeruns) * 4;
                stat_entry["runs+rbis"] = parseInt(stat_entry.runs) + parseInt(stat_entry.rbis);
                stat_entry["hits"] = parseInt(stat_entry.singles) + parseInt(stat_entry.doubles) + parseInt(stat_entry.triples) + parseInt(stat_entry.homeruns);
                stat_entry["hits+walks"] = parseInt(stat_entry.singles) + parseInt(stat_entry.doubles) + parseInt(stat_entry.triples)  + parseInt(stat_entry.homeruns) + parseInt(stat_entry.walks);
            }
        }
        else if(league == "nhl"){
            for(var stat_entry of chart_data){
                stat_entry["points"] = parseInt(stat_entry.goals) + parseInt(stat_entry.assists);
                stat_entry["shots on goal"] = parseInt(stat_entry.shots);
                stat_entry["blocked shots"] = parseInt(stat_entry.blocked_shots);
                stat_entry["power play points"] = parseInt(stat_entry.power_play_goals) + parseInt(stat_entry.power_play_assists);
                stat_entry["shots against"] = parseInt(stat_entry.shots_against);
                stat_entry["goals against"] = parseInt(stat_entry.goals_against);
            }
        }
        else if(league == "nfl"){
            for(var stat_entry of chart_data){
                stat_entry["rush yards"] = parseInt(stat_entry.rush_yards);
                stat_entry["pass yards"] = parseInt(stat_entry.pass_yards);
                stat_entry["rec yards"] = parseInt(stat_entry.rec_yards);
                stat_entry["rush tds"] = parseInt(stat_entry.rush_tds);
                stat_entry["pass tds"] = parseInt(stat_entry.pass_tds);
                stat_entry["rec tds"] = parseInt(stat_entry.rec_tds);
                stat_entry["total yards"] = parseInt(stat_entry.rush_yards) + parseInt(stat_entry.pass_yards) + parseInt(stat_entry.rec_yards);
                stat_entry["total tds"] = parseInt(stat_entry.rush_tds) + parseInt(stat_entry.pass_tds) + parseInt(stat_entry.rec_tds);
                stat_entry["interceptions"] = parseInt(stat_entry.off_interceptions);
            }
        }
        for (var game of chart_data){
            labels.unshift(new Date(game.player_game.game.start_time.replace(/-/g, "/")).toLocaleDateString("default",{month:'short', day:"numeric"}));
            data.unshift(parseFloat(game[selected_prop]));
        }
        return {
            labels: labels,
            datasets: [
                {
                    backgroundColor: [
                        "rgb(255, 99, 132)",
                        "rgb(255, 99, 132)",
                        "rgb(255, 99, 132)",
                        "rgb(255, 99, 132)",
                        "rgb(54, 162, 235)",
                        "rgb(54, 162, 235)",
                        "rgb(54, 162, 235)",
                    ],
                    data: data,
                },
            ],
        };
    }
    function getChartOptions() {
        let annotations = {};
        //check if line_value is not null
        if(line_value){
            annotations = {
                line1: {
                    type: "line",
                    yMin: line_value,
                    yMax: line_value,
                    borderDash: [10, 10],
                    borderColor: "gray",
                    borderWidth: 2,
                },
            }
        }
        else{
            annotations = {
            }
        }
        return {
            plugins: {
                legend: {
                    display: false
                },
                annotation: {
                    annotations: annotations,
                },
            },
        };
    }
    function setColors(myChart){
        var bars = myChart.data.datasets[0].data;
        for (let i = 0; i < bars.length; i++) {
            if (bars[i] < line_value) {
                myChart.data.datasets[0].backgroundColor[i] = 'rgb(255, 99, 132)';
            } else if (bars[i] > line_value) {
                myChart.data.datasets[0].backgroundColor[i] = "#4CB963";
            } else {
                myChart.data.datasets[0].backgroundColor[i] = "gray";
            }
        }
    }
    function updateChart(myChart, updateData = false) {
        if (updateData) {
            myChart.data = getChartData();
        }
        setColors(myChart);
        myChart.options = getChartOptions();
        myChart.update();
    }
    function initChart() {
        ctx = canvas.getContext("2d");
        chart = new Chart(ctx, {
            type: "bar",
            data: getChartData(),
            options: getChartOptions(),
        });
        setColors(chart);
        chart.update();
    }
    onMount(() => {
        initChart();
    });
</script>

<canvas style="max-height:250px;" bind:this={canvas} />
